// PATH: src/auth/access.ts
/**
 * Qui peut quoi dans l'administration des contenus. Deux profils :
 *
 * - administrateur (type de compte `admin`) : tout ;
 * - relecteur (rôle `REVIEWER`, accordé nominativement) : lit les chapitres et
 *   la couverture, décide la relecture (« Valider » / « À corriger »), et
 *   tranche les quêtes partagées signalées (« Quêtes à corriger »).
 *   Rien d'autre : ni import, ni suppression, ni extraction, ni catalogue, ni
 *   réglages, ni essais d'extraction. tc_embed_be (RequireReviewer) et
 *   tc_learn (`require_reviewer`) appliquent la même règle : l'écran n'est
 *   qu'un reflet, les serveurs refusent le reste en 403.
 */

/** Code de type utilisateur admin (aligné sur tc_identity CODIFICATION_CODE_ADMIN). */
export const ADMIN_USER_TYPE_CODE = "admin";

/** Rôle du relecteur, dans le claim `roles` du jeton (tc_ecosys 0119). */
export const REVIEWER_ROLE = "REVIEWER";

export type Access = "admin" | "reviewer" | "none";

export interface AccessSubject {
  userTypeCode?: string | null;
  roles?: readonly string[] | null;
}

/** Profil d'un utilisateur ; l'administrateur l'emporte sur le relecteur. */
export const accessOf = (user: AccessSubject | null | undefined): Access => {
  if (!user) return "none";
  if (user.userTypeCode === ADMIN_USER_TYPE_CODE) return "admin";
  if (Array.isArray(user.roles) && user.roles.includes(REVIEWER_ROLE)) return "reviewer";
  return "none";
};

/** Écrans ouverts au relecteur (le reste le renvoie vers les chapitres). */
export const REVIEWER_PATHS: readonly string[] = ["/coverage", "/chapters", "/quest-review"];

/** Page d'arrivée d'un relecteur qui demande un écran fermé. */
export const REVIEWER_HOME = "/chapters";

export const canVisit = (access: Access, path: string): boolean => {
  if (access === "admin") return true;
  if (access === "reviewer") return REVIEWER_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
  return false;
};

/** Message affiché à un compte connecté qui n'a aucun des deux profils. */
export const ACCESS_DENIED_MESSAGE = "Accès réservé aux administrateurs et aux relecteurs.";
